import { defaultCatalogSortBy, defaultSortBy } from 'constants/listings';

export const truncate = (string, len) => {
  if (string.length < len) return string;
  const subString = string.substr(0, len - 1);
  return `${subString.substr(0, subString.lastIndexOf(' '))}...`;
};

export const updateArrObjKey = (list, newItem, idKey, newKey) =>
  list.map(l => (l[idKey] === newItem[idKey] ? { ...l, [newKey]: newItem[newKey] } : l));

export const isFilterSelected = filters => {
  const {
    estimateLow,
    estimateHigh,
    freeSearchString,
    categories,
    metals,
    estimateRanges,
    gemstones,
    jewelryStyles,
    jewelryTypes,
    brandsAndDesigners,
    catalogNumber
  } = filters;
  return (
    (catalogNumber && catalogNumber !== '') ||
    (estimateHigh && estimateHigh !== '') ||
    (estimateLow && estimateLow !== '') ||
    (freeSearchString && freeSearchString !== '') ||
    jewelryStyles.length > 0 ||
    gemstones.length > 0 ||
    metals.length > 0 ||
    estimateRanges.length > 0 ||
    categories.length > 0 ||
    jewelryTypes.length > 0 ||
    brandsAndDesigners.length > 0
  );
};

export const getDefaultSortValue = (isMyLotsPage, isCatalog) => {
  switch (true) {
    case isMyLotsPage:
      return defaultSortBy;
    case isCatalog:
      return defaultCatalogSortBy;
    default:
      return [];
  }
};
